import axios from "axios";

const API_ENDPOINT =
  "https://oqfjiga75l.execute-api.ap-southeast-1.amazonaws.com/production/agent-activity";

const state = () => ({
  totalAgents: 0,
  activeAgents: 0,
  agents: [],
  agentMetrics: [],
});

const getters = {
  totalAgents: (state) => state.totalAgents,
  activeAgents: (state) => state.activeAgents,
  agents: (state) => state.agents,
  agentMetrics: (state) => state.agentMetrics,
};

const mutations = {
  SET_DASHBOARD_DATA(state, data) {
    state.totalAgents = data.totalAgents;
    state.activeAgents = data.activeAgents;
    state.agents = data.agents;

    console.log("Dashboard data set:", data);
  },
};

const actions = {
  async getDashboardData(context) {
    const response = await axios.get(API_ENDPOINT + "/dashboard");
    context.commit("SET_DASHBOARD_DATA", response.data.data);
  },

  async getAgentMetrics(context, { agentId, startDate, endDate }) {
    const url = `${API_ENDPOINT}/metrics/${agentId}?startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(endDate)}`;
    const response = await axios.get(url);
    return response.data.data;
  },

  async getAgentTimeline(context, { agentId, startDate, endDate }) {
    const url = `${API_ENDPOINT}/timeline/${agentId}?startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(endDate)}`;
    const response = await axios.get(url);
    return response.data.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
